import axios from '../utils/axios'

export function getIntegralCentreInfoApi() {
  return axios.post('/funds/apiFundsAh5Service/userIntegralCentre')
}

export function getIntegralListApi(params) {
  return axios.post('/funds/apiFundsAh5Service/userIntegralDetailList', params)
}

export function getIntegralRuleApi(params) {
  return axios.post('/funds/apiFundsAh5Service/integralRule', params)
}

export function getIntegralShopCouponListApi(params) {
  return axios.post('/settle/apiSettleAwService/integralShopCouponList', params)
}

export function receiveIntegralCouponApi(params) {
  return axios.post('/settle/apiSettleAwService/receiveIntegralCoupon', params)
}

export function getUserIntegralInfoApi(params) {
  return axios.post('/settle/apiSettleAwService/userIntegralInfo', params)
}

export function getStateIsEmptyApi(params) {
  return axios.post('/settle/apiSettleAwService/integralShopIndex', params)
}

export function getIntegralShopGoodsListApi(params) {
  return axios.post('/settle/apiSettleAwService/integralShopGoodsList', params)
}

export function getIntegralShopCouponDetailApi(params) {
  return axios.post('/settle/apiSettleAwService/integralShopCouponDetail', params)
}

export function getParamsCouponDetail(params) {
  return axios.post('/settle/apiSettleAwService/paramsCouponDetail', params)
}

export function receiveCouponApi(params) {
  return axios.post('/settle/apiSettleAwService/receiveCoupon', params)
}
